module.exports = __webpack_public_path__ + "img/total-floors.616507d6.svg";